<template>
<form class="w-full" novalidate @submit.prevent="">
	<div class="pdb-0">
		<div :class="$route.name === 'LessonView' ? 'pdt-5 pdb-5 pdl-16' : 'pdt-2 pdb-2'">
			<textarea id="autoheighttext"
				ref="msg" v-model="msg" :placeholder="$t('1203')" class="cursor-blue video-chat-textarea mdc-text-field__input comment_textarea t-body6 font-r l-spacing42 mgt-12 mgb-8 pdr-23 t-color-headlineBlack" rows="1">
			</textarea>
		</div>
		<div v-show="isAttachments" class="d-flex flex-wrap">
		<div class="divider-white"></div>
			<div v-for="(attachment, index) in attachments" :key="index" class="square-image attached-image-preview-QA mb-1 mgb-8" :class="{'mgl-16': $route.name === 'LessonView'}">
			<img :src="attachment.resourceUri" alt="Image" tabindex="0" @click="fileDisply(attachment)" @keypress="fileDisply(attachment)" />
			<span class="remove-img remove-image-new position-absolute t-color-white" tabindex="0" @click="attachments.splice(index, 1)" @keypress="attachments.splice(index, 1)">
				<i class="material-icons t-body1">close</i></span>
			</div>
		</div>
		<div class="divider-white"></div>
		<div v-if="qaType === 'exam'" class="d-flex align-items-center justify-content-between pdt-4 pdb-4">
			<div class="d-flex flex-grow-1 justify-content-between">
				<button id="btnPhoto" :class="setIconActiveMode" class="material-icons mdc-icon-button" tabindex="0" @click="openFileUpload('uploadChatFile')" @keypress="openFileUpload('uploadChatFile')">collections</button>
				<input id="uploadChatFile" ref="imageFiles" :accept="allowImgExt()" class="d-none" multiple type="file" @change="uploadChatFile()"/>

				<button :disabled="!isSendBtn"
					class="mdc-icon-button sendMessageBtnExam t-color-iconInactive align-items-center justify-content-between" tabindex="0" @click="sendChat()" @keypress="sendChat()">
					<i class="material-icons min-w-26 min-h-27">arrow_upward</i>
				</button>
			</div>
		</div>

		<div v-else class="d-flex align-items-center justify-content-between pdt-4 pdb-4">
			<div v-if="$route.name === 'LessonView'" class="d-flex flex-grow-1 justify-content-between">
				<button id="btnPhoto" :class="[setIconActiveMode, $route.name === 'LessonView' ? 'mgl-4': 'mgl--12']" class="material-icons mdc-icon-button " tabindex="0" @click="openFileUpload('uploadChatFile')" @keypress="openFileUpload('uploadChatFile')">collections</button>
				<input id="uploadChatFile" ref="imageFiles" :accept="allowImgExt()" class="d-none" multiple type="file" @change="uploadChatFile()" @keypress="uploadChatFile()" />
				<button :class="setIconActiveBackground" :disabled="!isSendBtn"
                class="mdc-icon-button align-items-center justify-content-between mgr-4" tabindex="0" @click="sendChat()" @keypress="sendChat()">
					<i :class="lightModeActive ? 't-color-whiteHighLight' : 't-color-contentsDarkmodeAppbar'" class="material-icons min-w-24 min-h-24">arrow_upward</i>
				</button>
			</div>
      <div v-else class="d-flex flex-grow-1 justify-content-between c">
        <button id="btnPhoto" :class="attachments.length <= 0 ? 't-color-iconInactive' : 'sendMessageBtnActive'" class="material-icons mdc-icon-button mgl--12" tabindex="0" @click="openFileUpload('uploadChatFile')" @keypress="openFileUpload('uploadChatFile')">collections</button>
        <input id="uploadChatFile" ref="imageFiles" :accept="allowImgExt()" class="d-none" multiple type="file" @change="uploadChatFile()" @keypress="uploadChatFile()" />
        <button :class="isSendBtn ? 'sendMessageBtnActive' : 'sendMessageBtn'" :disabled="!isSendBtn"
                class="mdc-icon-button align-items-center justify-content-between mgr-12" tabindex="0" @click="sendChat()" @keypress="sendChat()">
          <i class="t-color-whiteHigh material-icons min-w-24 min-h-24">arrow_upward</i>
        </button>
      </div>
		</div>
	</div>
</form>
</template>

<script>
/**
 * 나의학습/시험 질문하기 - 채팅 등록 컴포넌트(my learn / exam question - chatting write component)
 *
 * @author minkyoung.park@emcast.com
 */
import chatApi from '@/api/chatApi.js'
import { fileMixin } from '@/mixins/file.js'
import {MDCRipple} from '@material/ripple'

export default {
	props: ['learnId','lessonId','roomId', 'examineeId', 'questionId', 'lightModeActive'],

	data() {
		return {
			mentionSelector: false,
			msg: '',
			attachments: [],
			qaType:''
		}
	},

	mixins: [fileMixin],

	computed: {
		isSendBtn() {
      return !!this.msg || !!this.attachments.length
    },

    setIconActiveMode() {
      if(this.attachments.length <= 0) {
        return this.lightModeActive ? 't-color-iconInactive' : 't-color-whiteDisabled';
      } else {
        return this.lightModeActive ? 't-color-whiteHigh2' : 't-color-whiteHigh';
      }
    },

    setIconActiveBackground() {
      if(this.lightModeActive) {
        return this.isSendBtn ? 'sendMessageBtnActive' : 'sendMessageBtn';
      } else {
        return this.isSendBtn ? 'sendMessageLessonBtn' : 'sendMessageBtn';
      }
    }
	},

  updated() {
    this.isAttachments();
  },

	mounted() {
		this.setMaterialUi()
		if (this.$route.meta.chatType === 'exam') {
			this.qaType = 'exam'
		} else {
			this.qaType = ''
		}
	},

	methods: {
    isAttachments() {
      return this.attachments.length
    },

		onMentionClick(target) {
			this.msg += '@' + target + ' '
			this.mentionSelector = !this.mentionSelector
			this.$refs.msg.focus()
		},

		toggleMentionSelector() {
			this.mentionSelector = !this.mentionSelector
		},

		sendChat() {
			if (this.$route.meta.chatType === 'exam') {
				// for exam question
				this.sendExamChat()
			}else {
				// for my learn
				this.sendLearnChat()
			}
		},

		// regist chat for exam
		sendExamChat() {
			let params = {
				examineeId: this.examineeId,
				questionId: this.questionId,
				roomId: this.roomId > 0 ? this.roomId : null,
				msg: this.msg,
				attachments: this.attachments
			}

			chatApi.examChatroomChat(params).then((response) => {
				this.msg = ''
				this.attachments = []
				this.$emit('updateListData', response.data.data)
			}).catch((err) => {

			})
		},

		sendLearnChat() {
			let params = {
				learnId: this.learnId,
				lessonId: this.lessonId,
				roomId: this.roomId > 0 ? this.roomId : null,
				msg: this.msg,
				attachments: this.attachments
			}


			chatApi.learnChatroomChat(params).then((response) => {
				this.msg = ''
				this.attachments = []
				this.$emit('updateListData', response.data.data)
				let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
				let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
				if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
					localStorage.removeItem('videoBookMarkLesson');
					this.$router.push({
						name: 'BookMarkedLesson'
					})
				}else if(goBackLikeLessson=='setVideoLikeLesson'){
					localStorage.removeItem('videoLikeLesson');
					this.$router.push({
						name: 'LikedLesson'
					})
				} else {

				}
			}).catch((err) => {

			})
		},

		takeSurvey(id,respondentId,surveyDistributionType) {
			 let params = {
				distId: id,
				respondentId: respondentId,
			}

			this.$router.push({
				name: 'IndependentSurveyIntro',
				params: params,
				query:{status:this.$route.query.status,learnId:this.$router.currentRoute.params.learnId,distributionType:surveyDistributionType}
			})
		},

		fileDisply(data) {
			localStorage.setItem("chatImage", JSON.stringify(data));
            this.$router.push({
                name: 'ChatImageInLarge',
                params: this.$route.params,
                query: this.$route.query

            })
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}
</script>
<style scoped>
	/* .video-chat-textarea{
		width: calc(100% - 32px);
	} */

  .sendMessageLessonBtn i {
    background-color: var(--WhiteHigh);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }

.square-image.attached-image-preview-QA {
    max-width: 48px;
    position: relative;
}
.remove-image-new {
    top: -10px;
    right: -10px;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    background: var(--Iconinactive);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: 2px solid var(--DocumentWhite);
    color: var(--DocumentWhite);
    line-height: 0px;
    cursor: pointer;
}
html[dir="rtl"] .remove-image-new {
    left: -10px;
}
</style>
